import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import {
	ViewChildren,
	QueryList,
	ChangeDetectionStrategy,
	Input,
	OnChanges,
	Output,
	EventEmitter
} from '@angular/core';
import { SuiModal, ComponentModalConfig, ModalSize } from '@richardlt/ng2-semantic-ui';
import { DOCUMENT } from '@angular/common';
import { debounceTime, takeUntil, distinctUntilChanged, tap, map } from 'rxjs/operators';
import { Validators, FormGroup, FormControl, FormBuilder } from '@angular/forms';
interface IAdvanceSearchModalContext {
	header: any;
	title?: string;
	fieldx?: any[];
}
interface IHeaders {
	field?: string;
	label?: string;
	type?: string;
	choices?: any[];
	op?: string;
	data?: any;
}
@Component({
	selector: 'app-advance-search-modal',
	templateUrl: './confirm-modal.component.html',
	styleUrls: [ './confirm-modal.component.scss' ]
})
export class AdvanceSearchModalComponent implements OnInit, OnDestroy {
	@Input() searchName: string = '';
	headers: any[];
	@Output() submitSearch = new EventEmitter();
	@Output() onCancel = new EventEmitter();

	fieldx: Array<IHeaders> = [];
	fieldMap = new Map();
	operators = [
		{ id: 'cn', name: 'contains' },
		{ id: 'nc', name: 'does not contain' },
		{ id: 'eq', name: 'equal' },
		{ id: 'ne', name: 'not equal' },
		{ id: 'lt', name: 'less' },
		{ id: 'le', name: 'less or equal' },
		{ id: 'gt', name: 'greater' },
		{ id: 'ge', name: 'greater or equal' },
		{ id: 'bw', name: 'begins with' },
		{ id: 'bn', name: 'does not begin with' },
		{ id: 'ew', name: 'ends with' },
		{ id: 'en', name: 'does not end with' }
	];
	oldoperators = [ { id: 'cn', name: 'contains' }, { id: 'eq', name: 'equal' } ];
	groupOperators = [ { id: 'AND', name: 'AND' }, { id: 'OR', name: 'OR' } ];
	mode = 'date';
	searchFilter = {
		groupOp: 'AND',
		rules: []
	};

	selectForm = new FormControl();

	constructor(@Inject(DOCUMENT) private document, public modal: SuiModal<IAdvanceSearchModalContext, void, void>) {
		this.headers = modal.context.header;
		this.fieldx = modal.context.fieldx;
		console.log(this.fieldx);
		console.log(this.modal.context);
	}

	changeCondition(value) {
		this.searchFilter.groupOp = value.target.value;
	}

	logSelected(selected) {
		// console.log(selected)
	}
	trackByIndex(index: number, value: any) {
		if (value.type === 'date' && value.data instanceof Date) {
			return value.id;
		} else if (value.type === 'date' && !(value.date instanceof Date)) {
			let d = value.data.split('.')[0];
			value.data = new Date(d);
			return value.id;
		} else {
			return value.id;
		}
	}
	selectedOperator(op, item) {
		// this.fieldMap.set(field.id, field)
	}
	add() {
		if (this.selectForm.value && this.selectForm.value !== '') {
			this.fieldx.push(Object.assign({}, this.selectForm.value));
		}
	}
	remove(index) {
		this.fieldx.splice(index, 1);
	}

	setRule(item) {}

	changeOperators(event) {
		if (event.contractorType === null) {
			this.fieldx[event.index].op = 'eq';
		} else {
			this.fieldx[event.index].op = 'cn';
		}
	}

	submit() {
		let arr = [ ...this.fieldx ];
		let fields = [];
		arr.forEach((item) => {
			if (item.type === 'date' && item.data instanceof Date) {
				item.data = item.data.toISOString().split('.')[0];
				fields.push({ field: item.field, op: item.op, data: item.data });
			} else {
				fields.push({ field: item.field, op: item.op, data: item.data });
			}
		});
		let search: any = Object.assign({}, this.searchFilter);
		search.rules = fields;
		// this.submitSearch.emit(Object.assign({}, search));
		let payload: any = { search: search, filter: this.fieldx };
		this.modal.approve(payload);
	}
	cancel() {
		this.modal.deny(null);
	}
	ngOnInit() {
		this.document.body.classList.remove('panel');
	}
	// s
	ngOnDestroy(): void {
		this.document.body.classList.add('panel');
	}
}

export class AdvanceSearchModal extends ComponentModalConfig<IAdvanceSearchModalContext, void, void> {
	constructor(title: string, header: any, fieldx: any, size: ModalSize = ModalSize.Small) {
		super(AdvanceSearchModalComponent, { title, header, fieldx });

		this.isClosable = false;
		this.transitionDuration = 200;
		// this.size = size;
		this.isFullScreen = false;
		this.isInverted = false;
	}
}
